import * as React from 'react';

import TaskList56 from './TaskList56';

export const taskList56 = () => <TaskList56 />;

export default {
    title: 'Illustration/TaskList56',
    component: TaskList56,
    parameters: {
        notes: "`import TaskList56 from 'box-ui-elements/es/illustration/TaskList56';`",
    },
};
